export default __webpack_public_path__ + "static/media/undraw_fast_loading_re_8oi3.3aae1904.svg";